<template lang="pug">
  main#conteudo
    .container-fluid(style="padding: 0;")
      banner
    .container
      .row
        .col-xs-12
          noticias(:reference="true")
        .col-xs-12
          hr.-normal
      .row
        .col-xs-12
          sobre
        .col-xs-12
          hr.-normal
      .row
        .col-xs-12
          diretorias(:breakpoints='[[768, 3], [1024, 4]]')
        .col-xs-12
          hr.-normal
      .row
        .col-xs-12.col-sm-6
          coordenadorias(:breakpoints='[[768, 1], [1024, 2]]')
        .col-xs-12.visible-xs
          hr.-normal
        .col-xs-12.col-sm-6
          assessoria
    links-importantes
</template>

<script>
  import Assessoria from 'MODULES/Assessoria'
  import Banner from 'COMPONENTS/Banner'
  import Coordenadorias from 'MODULES/Coordenadorias'
  import Diretorias from 'MODULES/Diretorias'
  import LinksImportantes from 'COMPONENTS/LinksImportantes'
  import Noticias from 'MODULES/Noticias'
  import Sobre from 'MODULES/Sobre'

  import * as config from '../../js/config'

  export default {
    components: {
      Assessoria,
      Banner,
      Coordenadorias,
      Diretorias,
      LinksImportantes,
      Noticias,
      Sobre
    },
    head: {
      title: function () {
        return {
          inner: config.SITE_TITLE + ' - Página Principal'
        }
      },
      meta: [
        {
          name: 'description', content: config.SITE_DESC, id: 'description'
        }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?48261a87